define([
    'common/domain/entity/blob',
    'moment',
    'backbone'
], function(
    BlobModel,
    Moment,
    Backbone
    ) {
    /**
     * @exports collections/blob-collection
     */
    var BlobCollection = Backbone.Collection.extend({
        /**
         * Backbone.Collection を extend した BlobCollection を定義する
         */
        model: BlobModel,
        comparator: function(blob) {
            return blob.get('filename');
        }
    });

    return BlobCollection;
});



// WEBPACK FOOTER //
// ./common/domain/collection/blob.js